import { render, staticRenderFns } from "./FacebookIntegration.vue?vue&type=template&id=69bb9992&scoped=true"
import script from "./FacebookIntegration.vue?vue&type=script&lang=js"
export * from "./FacebookIntegration.vue?vue&type=script&lang=js"
import style0 from "./FacebookIntegration.vue?vue&type=style&index=0&id=69bb9992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bb9992",
  null
  
)

export default component.exports